import './style.scss';

const priceRows = [
    { time: '1 час', day: '80 сом', evening: '100 сом' },
    { time: '3 часа', day: '210 сом', evening: '270 сом' },
    { time: '5 часов', day: '330 сом', evening: '380 сом' },
    { time: '7 часов', day: '420 сом', evening: '490 сом' },
    { time: 'Мега утро (06:00 – 12:00)', day: '250 сом', evening: '—' },
    { time: 'Ночь (21:00 – 08:00)', day: '—', evening: '400 сом' },
];

const Tarifs = () => {
    return (
        <div className="tarifs-container">
            <div className="tarifTitle">ПРАЙС</div>

            <table className="tarif-table">
                <thead>
                    <tr>
                        <th className="th-time">
                            <div className="timeDiv">Время</div>
                        </th>
                        <th className="th-day">
                            <div className="zoneTitle day-title">
                                День
                                <span>08:00 – 16:00</span>
                            </div>
                        </th>
                        <th className="th-evening">
                            <div className="zoneTitle evening-title">
                                Вечер
                                <span>16:00 – 08:00</span>
                            </div>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {priceRows.map((row) => (
                        <tr key={row.time}>
                            <td className="td-time">
                                <div>{row.time}</div>
                            </td>
                            <td className="td-day">
                                <div>{row.day}</div>
                            </td>
                            <td className="td-evening">
                                <div>{row.evening}</div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Tarifs;
